/** https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role */
export default function ThimEkitsTabs() {
	const tabList = document.querySelector( '.thim-ekit-tablist [role="tablist"]' );

	if (! tabList) {
		return;
	}

	const tabs = document.querySelectorAll( '.thim-ekit-tablist [role="tab"]' );

	// Add a click event handler to each tab
	tabs.forEach( ( tab ) => {
		tab.addEventListener( 'click', changeTabs );
	} );

	// Enable arrow navigation between tabs in the tab list
	let tabFocus = 0;

	tabList.addEventListener( 'keydown', ( e ) => {
		// Move right
		if (e.keyCode === 39 || e.keyCode === 37) {
			tabs[tabFocus].setAttribute( 'tabindex', -1 );
			if (e.keyCode === 39) {
				tabFocus++;
				// If we're at the end, go to the start
				if (tabFocus >= tabs.length) {
					tabFocus = 0;
				}
				// Move left
			} else if (e.keyCode === 37) {
				tabFocus--;
				// If we're at the start, move to the end
				if (tabFocus < 0) {
					tabFocus = tabs.length - 1;
				}
			}

			tabs[tabFocus].setAttribute( 'tabindex', 0 );
			tabs[tabFocus].focus();
		}
	} );
}

function changeTabs( e ) {
	const target = e.currentTarget;
	const parent = target.parentNode;
	const grandparent = parent.parentNode;

	// Remove all current selected tabs
	if (grandparent.classList.contains( 'thim-accordion-sections' )) {
		grandparent
			.querySelectorAll( '[aria-selected="true"]' )
			.forEach( ( t ) => t.setAttribute( 'aria-selected', false ) );
	} else {
		parent
			.querySelectorAll( '[aria-selected="true"]' )
			.forEach( ( t ) => t.setAttribute( 'aria-selected', false ) );
	}

	// Set this tab as selected
	target.setAttribute( 'aria-selected', true );

	// Hide all tab panels
	grandparent
		.querySelectorAll( '[role="tabpanel"]' )
		.forEach( ( p ) => p.setAttribute( 'hidden', true ) );

	// Show the selected panel
	grandparent.parentNode
		.querySelector( `#${ target.getAttribute( 'aria-controls' ) }` )
		.removeAttribute( 'hidden' );
}

( function( $ ) {
	'use strict';

	$( document ).on( 'click', '.thim-ekit-tablist a[href^="#"]', function( event ) {
		event.preventDefault();

		$( 'html, body' ).animate( {
			scrollTop: $( $.attr( this, 'href' ) ).offset().top - 100,
		}, 500 );
		$( '.thim-ekit-tablist' ).find( '.active' ).removeClass( 'active' );
		$( this ).addClass( 'active' );
	} );

} )( jQuery );
